import { render, staticRenderFns } from "./RedBerries.vue?vue&type=template&id=7580374c&scoped=true&"
import script from "./RedBerries.vue?vue&type=script&lang=js&"
export * from "./RedBerries.vue?vue&type=script&lang=js&"
import style0 from "./RedBerries.vue?vue&type=style&index=0&id=7580374c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7580374c",
  null
  
)

export default component.exports